import React from 'react';
// FIX: Import all potentially used icons directly to avoid namespace import issues.
import { 
    Search, Shield, Award, AlertCircle, FileText, EyeOff, Activity, Video, 
    Smartphone, Target, Phone, Heart, Users, DollarSign, Clock, Home, Zap, 
    Sliders, TrendingUp, Map, Edit, GitMerge, CheckSquare 
} from 'react-feather';
import type { MechanismStep } from '../../types';
import AnimatedSection from '../ui/AnimatedSection';

// Create a local map to look up icon components by their string name.
// This replicates the functionality of `Icon[step.icon]` without using a namespace import,
// which has been a consistent source of build/runtime errors.
const iconMap: { [key: string]: React.ElementType } = {
    Search, Shield, Award, AlertCircle, FileText, EyeOff, Activity, Video, 
    Smartphone, Target, Phone, Heart, Users, DollarSign, Clock, Home, Zap, 
    Sliders, TrendingUp, Map, Edit, GitMerge, CheckSquare
};


interface MechanismDiagramProps {
    mechanism: {
        title: string;
        subtitle: string;
        steps: MechanismStep[];
    }
}

const MechanismDiagram: React.FC<MechanismDiagramProps> = ({ mechanism }) => {
    // DEFINITIVE FIX: Prevent component from rendering if data is incomplete, avoiding crashes.
    if (!mechanism?.steps || mechanism.steps.length === 0) {
        return null;
    }

    return (
        <AnimatedSection>
            <div className="py-24 bg-white/5">
                <div className="mx-auto max-w-7xl px-6">
                    <div className="mx-auto mb-16 max-w-3xl text-center">
                        <h2 className="text-4xl md:text-5xl font-serif font-bold">{mechanism.title}</h2>
                        <p className="mt-4 text-lg text-white/80">{mechanism.subtitle}</p>
                    </div>
                    <div className="relative grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div className="absolute top-10 left-0 w-full h-px bg-white/10 hidden md:block"></div>
                        {mechanism.steps.map((step, index) => {
                            // Use the icon map to get the component, with AlertCircle as a safe fallback.
                            const FeatherIcon = iconMap[step.icon] || AlertCircle;
                            return (
                                <div key={index} className="relative flex flex-col items-center text-center">
                                    <div className="w-20 h-20 rounded-full gold-gradient-bg flex items-center justify-center text-black mb-6 z-10 ring-8 ring-white/5">
                                        <FeatherIcon size={32} />
                                    </div>
                                    <h3 className="text-xl font-bold mb-3">{step.title}</h3>
                                    <p className="text-white/80">{step.description}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </AnimatedSection>
    );
};

export default MechanismDiagram;